<template>
  <div class="pageContol listWrap templateList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">培训管理</a>
          <i>></i>
          <a href="javascript:;" @click="goHerf" class="cur-a">问卷活动管理</a>
          <i>></i>
          <a href="javascript:;" @click="goHerf2" class="cur-a">反馈记录</a>
          <i>></i>
          <a href="javascript:;" @click="init" class="cur-a">预览</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="ovy-a">
          <div class="searchbox changetreestyle">
            <div
              class="flexdc"
              style="align-items: flex-start; background:rgba(241, 247, 253, 1)"
            >
              <div style="padding:20px" class="rowJsontitle">
                <!-- <div>
                  <span>
                    班级名称：
                    <em style="color: #5c6be8;font-size:15px">{{
                      form.projectName
                    }}</em>
                  </span>
                </div> -->
                <!-- <div>
                  <span>
                    课程名称：
                    <em style="color: #5c6be8;font-size:15px">{{
                      form.courseName
                    }}</em>
                  </span>
                </div> -->
                <div>
                  <span style="font-size:24px">
                    问卷名称：
                    <em style="color: #5c6be8;font-size:24px">{{
                      form.paperName
                    }}</em>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="framePage-scroll flexdc">
            <div
              class="bottom searchbox"
              style="padding-top:0; padding-right:1rem"
            >
              <h3>{{form.paperDescription}}</h3>
            </div>
            <div class="ovy-a flex1" id="list-box">
              <div
                class="listExam"
                v-for="(item, index) in form.surveyQuestionList"
                :key="index"
              >
                <div class="list-item df">
                  <div class="subject flex1">
                    <div class="subject-title">
                      <span>{{ indexMethod(index) }}、</span>
                      <span>{{ item.questionName }}</span>
                    </div>
                    <div
                      class="option"
                      v-if="item.questionType != 30"
                      style="padding:0 30px 0 15px"
                    >
                    
                      <div
                        v-for="(item1, index) in item.optionList"
                        :key="index"
                        style="display:flex;align-items:center;margin:10px 0;justify-content: space-between;"
                        :style="{background: item1.optionName == item.content[0].content ? 'rgba(58, 209, 178, 0.1)':'',color: item1.optionName == item.content[0].content ? 'rgba(58, 209, 178, 1)':''}"
                      >
                        <span
                          >{{  optionFM(item1.optionOrder) }}、{{ item1.optionName }}
                          <i class="el-icon-check" v-if="(item1.optionId == item.content[0].optionId) || item1.choice" style="color:#3AD1B2;font-size:26px;opacity:1"></i>
                        </span>
                      </div>
                    </div>
                    <div class="option" v-else style="padding:15px 0 0 15px">
                      <span style="font-size:1rem;">{{
                        item.content[0].content 
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Empty from "@/components/Empty.vue";
import List from "@/mixins/List";
import { mapGetters } from "vuex";
export default {
  name: "set/courseUser",
  components: {
    // Empty,
  },
  mixins: [List],
  props: ["name"],
  data() {
    return {
      selectData: {
        catalogName: "",
      },
      editJson: {},
      form: {},
      stu:'',
    };
  },
  computed: {},
  created() {
    // this.init();
  },
  methods: {
    // 跳转反馈信息
    goHerf2() {
      this.$router.go(-1)
    },
    // 跳转调查活动
    goHerf() {
      this.$router.push({
        path: "/web/questionnaire/questionnaireActivity",
        query: {},
      });
    },
    init() {
      this.mobile = this.$route.query.mobile; // 手机号
      this.idCard = this.$route.query.idCard; // 身份证
      this.userName = this.$route.query.userName; // 用户名
      this.performanceId = this.$route.query.performanceId; // 作答记录id

      this.getDataList()
      this.getTableHeight();
    },
    optionFM(msg) {
      if (msg == 1) {
        return "A";
      } else if (msg == 2) {
        return "B";
      } else if (msg == 3) {
        return "C";
      } else if (msg == 4) {
        return "D";
      } else if (msg == 5) {
        return "E";
      } else if (msg == 6) {
        return "F";
      } else if (msg == 7) {
        return "G";
      }
    },
    getDataList() {
      const params = {
        mobile: this.mobile, // 手机号
        idCard: this.idCard, // 身份证
        userName: this.userName, // 用户名
        performanceId: this.performanceId, // 作答记录id
      };
      

      this.$post("/edu/project/paper/answer", params)
        .then((ret) => {
          console.log('ret', ret);
          this.form = ret.data || {};
        })
        .catch((err) => {
          return;
        });
      // this.doFetch({
      //   url: "/survey/sjzcx/summary",
      //   params,
      //   pageNum
      // });
    },
    DailysummaryDetail() {
      this.$router.push({
        path: "/web/set/questionnaireDailysummaryDetail",
        query: {
          projectCourseId,
          projectId,
        },
      });
    },
    goback() {
      this.$router.push({
        path: "/web/set/questionnaireDailysummary",
        query: {
          liuliuliu: true,
          projectCourseId: this.editJson.projectCourseId,
          projectId: this.editJson.projectId,
        },
      });
    },
    getTableHeight(opDom = true, page = true) {
      let tHeight =
        window.innerHeight - (3 + 1.35 + 3.25 + 0.675 + 2 + 1.35) * 16;
      if (opDom) {
        tHeight -= 40 + 0.675 * 16 + 1;
      }
      if (page) {
        tHeight -= 32;
      }
      this.tableHeight = tHeight;
    },
  },
  mounted: function() {},
};
</script>

<style lang="less" scope>
.courseUser {
  height: 100%;
}
.el-textarea {
  resize: none;
  .el-textarea__inner {
    height: 200px;
  }
}
.listWrap {
  .el-icon-arrow-down {
    font-size: 12px;
    &:before {
      content: "\e6df" !important;
    }
  }
  .el-tabs {
    flex: 1;
    display: flex;
    flex-direction: column;
    .el-tabs__content {
      flex: 1;
    }
  }
}
.btnBox {
  .el-button.is-disabled,
  .el-button.is-disabled:focus,
  .el-button.is-disabled:hover {
    background: #a9a9a9;
    border-color: #a9a9a9;
    color: #fff;
  }
}
.confirmButtonClass {
  color: #fff !important;
  background-color: #5c6be8 !important;
  border-color: #5c6be8 !important;
}
.el-table th.is-left {
  > .cell {
    text-align: left;
  }
}
.el-table th.is-right {
  > .cell {
    text-align: right;
  }
}
.subject {
  padding-left: 15px;
  .subject-title {
    font-size: 1rem;
  }
}
.listExam {
  margin: 15px 0;
  background: #fafafa;
  min-height: 7.5rem;
  .list-item {
    padding-top: 0.5rem;
  }
}
.rowJsontitle {
  padding: 20px;
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: space-around;
  > div {
    display: flex;
    align-items: center;
    font-size: 15px;
  }
}
</style>
